<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Adding</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div v-if="changed">
      <div class="container" style="padding: 0px">
        <b-modal
          v-model="modalShow"
          ok-only
          centered
          class="text-center text-info"
        >
          You have added maximum products/items. Please upgrade the package to
          add more products/items.
        </b-modal>
        <b-modal
          v-model="modalShow2"
          ok-only
          centered
          class="text-center text-info"
        >
          Product/Item Added.
        </b-modal>
        <div class="col-sm-12 col-lg-8 m-auto">
          <el-form
            :model="formdata"
            :rules="rules"
            ref="formdata"
            label-width="200px"
            :label-position="labelPosition"
            size="medium"
            status-icon
            @submit.native.prevent
            style="
              border: 1px solid #e2e2e2;
              border-radius: 5px;
              background-color: #fff;
              padding: 20px;
            "
          >
            <h4
              class="text-center text-info mt-4"
              v-if="shopcat != 'Supermarket'"
            >
              Add {{ this.$route.params.cat }} items
            </h4>
            <h4
              class="text-center text-info mt-4"
              v-if="shopcat == 'Supermarket'"
            >
              Add items
            </h4>
            <div class="file-upload col-12 col-md-6" style="margin-top: 20px">
              <div class="image-upload-wrap" style="height: 100px">
                <input
                  class="file-upload-input"
                  type="file"
                  @change="fileSelect1"
                  accept=".jpg, .jpeg"
                />
                <div class="drag-text">
                  <h6 class="pt-3 pb-1">Add main image</h6>
                  <p>(maximum file size 5MB)</p>
                </div>
              </div>
              <div
                class="file-upload-content mx-auto text-center"
                :style="{ display: visible1 }"
              >
                <img
                  class="file-upload-image"
                  :src="formdata.imageUrl1"
                  alt=""
                />
              </div>
            </div>

            <!-- <div style="height: auto" class="mt-3 mb-4">
              <div class="file-upload">
                <div
                  class="image-upload-wrap col-12 col-md-6 m-auto"
                  style="height: 100px"
                >
                  <input
                    class="file-upload-input"
                    type="file"
                    multiple
                    @change="otherIMG"
                    accept=".jpg, .jpeg"
                  />
                  <div class="drag-text">
                    <h6 class="pt-3 pb-1">Add other images</h6>
                    <p>(maximum 4 images)</p>
                  </div>
                </div>
                <div class="row">
                  <div
                    v-for="(file, i) in imgfiles"
                    :key="i"
                    class="
                      file-upload-content
                      justify-item-center
                      col-12 col-sm-6 col-md-3
                    "
                    :style="{ display: visible2 }"
                  >
                    <div :style="{ display: visible2 }">
                      <img
                        class="file-upload-image"
                        style="margin-right: 0px"
                        :src="file"
                        alt="your image"
                      />
                      <div class="image-title-wrap mt-2">
                        <el-button
                          type="danger"
                          size="small"
                          @click="removeimg(i)"
                          >Remove Image</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <el-form-item label="Product Name" prop="name">
              <el-input
                v-model="formdata.name"
                clearable
                style="width: 220px"
              ></el-input>
            </el-form-item>

            <el-form-item label="Barcode/SKU" prop="barcode">
              <el-input
                v-model="formdata.barcode"
                clearable
                @change="checkBarcode"
                style="width: 220px"
              ></el-input>
            </el-form-item>

            <el-form-item label="Low Alert Quantity" prop="quantity">
              <el-input
                v-model.number="formdata.quantity"
                type="number"
                clearable
                style="width: 220px"
                :min="1"
              ></el-input>
            </el-form-item>

            <el-form-item label="Profit Margin" prop="profitmargin">
              <el-input
                type="number"
                :precision="2"
                v-model.number="formdata.profitMargin"
                class="input-with-select"
                style="width: 220px"
                clearable
                
              >
                <template slot="append"><i class="fa fa-percent"></i></template>
              </el-input>
            </el-form-item>

            <el-form-item label="Update Price List">
              <el-button type="primary" @click="showPriceTable = true"
                >Update Price List</el-button
              >
            </el-form-item>

            <!-- <el-form-item label="Retail Price List">
              <el-select
                v-model="formdata.priceList"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="Enter Selling Prices"
              >
                <el-option
                  v-for="item in formdata.priceList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item> -->

            <!-- <el-form-item
              label="Purchased Price List"
              prop="purchasedPriceList"
            >
              <el-select
                v-model="formdata.purchasedPriceList"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="Enter Purchased Prices according to retail prices"
              >
                <el-option
                  v-for="item in formdata.purchasedPriceList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="Online Store Price" prop="price">
              <el-input
                type="number"
                :precision="2"
                v-model.number="formdata.price"
                class="input-with-select"
                style="width: 220px"
                clearable
                
              >
                <template slot="prepend">RS</template>
              </el-input>
            </el-form-item>

            <el-form-item label="Discount" prop="dis">
              <el-input
                type="number"
                placeholder="Discount"
                v-model.number="formdata.dis"
                style="width: 220px"
              >
                <template slot="append"><i class="fa fa-percent"></i></template>
              </el-input>
            </el-form-item>

            <!-- <el-form-item label="Category" prop="category">
    <el-select v-model="formdata.category" placeholder="Category">
      <el-option label="cat one" value="shanghai"></el-option>
      <el-option label="cat two" value="beijing"></el-option>
    </el-select>
  </el-form-item>

<el-form-item label="Sub Category" prop="formdata.subcategory">
    <el-select v-model="formdata.subcategory" placeholder="Sub Category">
      <el-option label="subcat one" value="shanghai"></el-option>
      <el-option label="subcat two" value="beijing"></el-option>
    </el-select>
  </el-form-item> -->

            <!-- <el-form-item label="Category" prop="category">
    <el-select v-model="category" placeholder="Category">
      <el-option v-for="(hh, category) in categoriesList" :value="category" :key="category">{{category}}</el-option>
      
    </el-select>
  </el-form-item>

<el-form-item label="Sub Category" prop="formdata.subcategory">
    <el-select  :disabled="subcategories.length == 0"
    v-model="formdata.subcategory" placeholder="Sub Category">
      <el-option v-for="formdata.subcategory in subcategories" :key="formdata.subcategory" :value="formdata.subcategory">{{formdata.subcategory}}</el-option>
      
    </el-select>
  </el-form-item> -->

            <el-form-item label="Category" prop="category">
              <el-select v-model="category" placeholder="Category">
                <el-option :value="this.$route.params.cat">{{
                  this.$route.params.cat
                }}</el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Sub Category" prop="subcategory">
              <el-select
                v-model="formdata.subcategory"
                placeholder="Sub Category"
              >
                <el-option
                  v-for="(subcat, key) in Object.keys(subcategories).sort()"
                  :key="key"
                  :value="subcat"
                  >{{ subcat }}</el-option
                >
              </el-select>
            </el-form-item>

            <el-form-item label="Product Variations">
              <el-select
                v-model="formdata.variations"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="Enter Variations"
              >
                <el-option
                  v-for="item in formdata.variations"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Brand (if any)" prop="brand">
              <el-input
                v-model="formdata.brand"
                placeholder="Brand"
                style="width: 220px"
                clearable
              >
              </el-input>
            </el-form-item>

            <el-form-item label="Bin Location/Rack" prop="rack">
              <el-input
                v-model="formdata.rack"
                placeholder="Bin Location/Rack"
                style="width: 220px"
                clearable
              >
              </el-input>
            </el-form-item>

            <el-form-item
              label="Model"
              prop="model"
              v-if="this.$route.params.cat == 'Cameras'"
            >
              <el-input
                v-model="formdata.model"
                placeholder="Model"
                style="width: 220px"
                clearable
              >
              </el-input>
            </el-form-item>

            <el-form-item
              label="Karat/Carat"
              prop="krat"
              v-if="
                shoptype == 'Jewelry' ||
                shoptype == 'Gems' ||
                shoptype == 'Jewelry Gems & Watch'
              "
            >
              <el-input
                type="number"
                v-model.number="formdata.karat"
                class="input-with-select"
                style="width: 220px"
                clearable
              >
                <template slot="prepend">k</template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Metal/Stone"
              prop="metal"
              v-if="
                shoptype == 'Jewelry' ||
                shoptype == 'Gems' ||
                shoptype == 'Jewelry Gems & Watch'
              "
            >
              <el-input
                v-model="formdata.metal"
                placeholder="Metal/Stone"
                style="width: 220px"
                clearable
              >
              </el-input>
            </el-form-item>

            <el-form-item
              label="Author"
              prop="author"
              v-if="shopcat == 'Books'"
            >
              <el-input
                v-model="formdata.author"
                placeholder="Author"
                style="width: 220px"
                clearable
              >
              </el-input>
            </el-form-item>

            <el-form-item
              label="Publisher"
              prop="publisher"
              v-if="shopcat == 'Books'"
            >
              <el-input
                v-model="formdata.publisher"
                placeholder="Publisher"
                style="width: 220px"
                clearable
              >
              </el-input>
            </el-form-item>

            <el-form-item
              label="Screen Size"
              prop="screensize"
              v-if="formdata.subcategory == 'TV'"
            >
              <el-input
                v-model="formdata.screensize"
                placeholder="Screen Size"
                style="width: 220px"
                class="input-with-select"
                clearable
              >
                <template slot="prepend">inches</template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Size"
              prop="size"
              v-if="
                shopcat == 'Clothing & Accessories' ||
                shopcat == 'Shoes & Footwear' ||
                this.$route.params.cat == 'Tiles'
              "
            >
              <el-input
                v-model="formdata.size"
                placeholder="Size"
                style="width: 220px"
                clearable
              >
              </el-input>
            </el-form-item>

            <el-form-item
              label="Material"
              prop="material"
              v-if="
                shopcat == 'Clothing & Accessories' ||
                shopcat == 'Shoes & Footwear' ||
                this.$route.params.cat == 'Tiles' ||
                shoptype == 'Watch' ||
                shopcat == 'Bags' ||
                shopcat == 'Furniture' ||
                shopcat == 'Home Decor' ||
                shopcat == 'Handicrafts' ||
                shopcat == 'Baby Kids & Toys'
              "
            >
              <el-input
                v-model="formdata.material"
                placeholder="Material"
                style="width: 220px"
                clearable
              >
              </el-input>
            </el-form-item>

            <el-form-item label="Main Color" prop="color">
              <el-input
                v-model="formdata.color"
                placeholder="Color"
                style="width: 220px"
                clearable
              >
              </el-input>
            </el-form-item>

            <el-form-item label="Other Colors">
              <el-select
                v-model="formdata.colors"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="Enter Other Colors"
              >
                <el-option
                  v-for="item in formdata.colors"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Expire Date" prop="expireDate">
              <el-date-picker
                v-model="formdata.expireDate"
                type="date"
                placeholder="Expire Date"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="Condition" prop="cond">
              <el-select v-model="formdata.cond" placeholder="Condition">
                <el-option value="new">New</el-option>
                <el-option value="used">Used</el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="Item Type" prop="type">
    <el-select v-model="formdata.type" placeholder="Item Type">
      <el-option value="none">None</el-option> 
      <el-option value="latest">Latest Item</el-option> 
      <el-option value="bestselling">Best Selling Item</el-option> 
    </el-select>
  </el-form-item> -->

            <el-form-item label="Warranty" prop="warranty">
              <el-select
                filterable
                allow-create
                v-model="formdata.warranty"
                placeholder="Warranty"
                style="width: 220px"
                clearable
              >
                <el-option value="No Warranty">No Warranty</el-option>
                <el-option value="1 Months Warranty"
                  >1 Months Warranty</el-option
                >
                <el-option value="3 Months Warranty"
                  >3 Months Warranty</el-option
                >
                <el-option value="6 Months Warranty"
                  >6 Months Warranty</el-option
                >
                <el-option value="1 Year Warranty">1 Year Warranty</el-option>
                <el-option value="2 Year Warranty">2 Year Warranty</el-option>
                <el-option value="3 Year Warranty">3 Year Warranty</el-option>
                <el-option value="4 Year Warranty">4 Year Warranty</el-option>
                <el-option value="5 Year Warranty">5 Year Warranty</el-option>
                <el-option value="10 Year Warranty">10 Year Warranty</el-option>
                <el-option value="Lifetime Warranty"
                  >Lifetime Warranty</el-option
                >
              </el-select>
            </el-form-item>

            <!-- <button class="primary d-block" @click="pickFile" >Add Image</button>
<input type="file"  @change="fileSelect2" ref="fileInput"/>
<img :src="formdata.imageUrl"  width="360" height="240"> -->

            <el-form-item label="Product Description" prop="desc">
              <el-input
                type="textarea"
                v-model="formdata.desc"
                maxlength="1000"
                :autosize="{ minRows: 2, maxRows: 4 }"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('formdata')"
                >Add</el-button
              >
              <el-button @click="resetForm('formdata')">Reset</el-button>
            </el-form-item>
          </el-form>
          <el-dialog
            :width="priceTableWidth"
            :show-close="true"
            :close-on-click-modal="false"
            title="Update Prices"
            center
            :visible.sync="showPriceTable"
          >
            <PriceTable
              :priceData="formdata.priceData"
              :showPriceTable="showPriceTable"
              :profitMargin="formdata.profitMargin"
            />
          </el-dialog>

          <el-dialog
            :width="priceTableWidth"
            :show-close="true"
            :close-on-click-modal="false"
            title="Update Variations"
            center
            :visible.sync="showVariationsTable"
          >
            <PriceTable
              :variationsData="formdata.variations"
              :showVariationsTable="showVariationsTable"
            />
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageCompressor from "image-compressor.js";
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import PriceTable from "./PriceTable.vue";
import VariationsTable from "./VariationsTable.vue";
import mobiles from "../../data/mobiles";
import ClothingAccessories from "../../data/ClothingAccessories";
export default {
  name: "commonproducts",
  components: {
    PriceTable,
    VariationsTable
  },
  data() {
    var checkprice = (rule, value, callback) => {
      // if (value == undefined || value == "") {
      //   return callback(new Error("Please input the price"));
      // }
      setTimeout(() => {
        // if (!Number.isInteger(value)) {
        //   callback(new Error("Please input numbers"));
        // } else {
          if (value < 0) {
            callback(new Error("Price cannot be negetive"));
          } else {
            callback();
          }
        //}
      }, 100);
    };

    var checkdis = (rule, value, callback) => {
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("Discount should be 0 to 100"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    var defaultImage =
      "data:image/jpeg;base64,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";
    return {
      categoriesList: [],
      subcategories: {},
      category: "",
      tags: [],
      shops: [],
      shopcat: "",
      shoptype: "",
      cansearch: "no",
      modalShow: false,
      modalShow2: false,
      options: [],
      visible: "block",
      visible1: "none",
      visible2: "none",
      visible3: "none",
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      labelPosition: "",
      loading: false,
      loading1: false,
      changed: true,
      showPriceTable: false,
      showVariationsTable: false,
      priceTableWidth: "50%",
      image1: defaultImage,

      formdata: {
        name: "",
        price: 0,
        barcode: "",
        quantity: 1,
        profitMargin: 0,
        priceList: [],
        priceData: this.$store.state.stores.map((store) => {
          return {
            purcPr: 0,
            sellPr: 0,
            quantity: 0,
            serial: "",
            store: store.id,
          };
        }),
        purchasedPriceList: [],
        variations: [],
        colors: [],
        expireDate: "",
        dis: 0,
        disprice: 0,
        subcategory: "",
        brand: "",
        model: "",
        karat: "",
        metal: "",
        author: "",
        publisher: "",
        size: "",
        screensize: "",
        material: "",
        color: "",
        cond: "",
        type: "",
        warranty: "",
        desc: "",
        image: null,
        imageUrl1: "",
        imageUrl2: "",
        imageUrl3: "",
        owner: "",
        isLoggedIn: false,
        currentUser: false,
        prdstat: {},
        rack: '',
      },

      rules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
          {
            min: 3,
            max: 100,
            message: "Length should be 3 to 100",
            trigger: "blur",
          },
        ],
        barcode: [
          { required: true, message: "Please input barcode", trigger: "blur" },
        ],
        quantity: [
          { required: true, message: "Please input quantity", trigger: "blur" },
          {
            min: 1,
            type: "number",
            message: "Minimum quantity is 1",
            trigger: "blur",
          },
        ],
        price: [{ validator: checkprice, trigger: "blur" }],
        dis: [{ validator: checkdis, trigger: "blur" }],
        // purchasedPriceList: [
        //   { message: "Please select purchased Price", trigger: "change" },
        // ],
        category: [{ message: "Please select category", trigger: "change" }],
        subcategory: [
          {
            required: true,
            message: "Please select sub category",
            trigger: "change",
          },
        ],
        brand: [{ message: "Please select brand", trigger: "change" }],
        color: [{ message: "Please select picture", trigger: "blur" }],
        desc: [{ message: "Please input description", trigger: "blur" }],
      },
    };
  },

  watch: {
    // category () {
    //   this.subcategories = []
    //   this.formdata.subcategory = ""
    //   if (this.category.length > 0) {
    //           this.subcategories = this.categoriesList[this.category]
    //       }
    // },
    // shops () {
    //    if(this.shops[0].shoptype == 'Fashion'){
    //     this.categoriesList = ClothingAccessories
    // }
    // if(this.shops[0].shoptype == 'Elec'){
    //     this.categoriesList = mobiles
    // }
    // }
  },

  methods: {
    pickFile() {
      this.$refs.fileInput.click();
    },

    fileSelect1(event) {
      //console.log('event is', event)
      if (event.target.files.length > 0) {
        const files = event.target.files;
        let filename = files[0].name;
        //console.log('files[0].type', files[0].type)
        if (
          files[0].type == "image/png" ||
          files[0].type == "image/gif" ||
          files[0].type == "image/svg+xml" ||
          files[0].type == "image/tiff"
        ) {
          alert(
            "File " +
              files[0].name +
              " is not type of jpeg or jpg!. You cannot upload other types of images."
          );
        } else if (files[0].size > 5000200) {
          alert("File " + files[0].name + " is too large!");
        } else {
          const reader = new FileReader();
          reader.addEventListener("load", () => {
            this.visible = "none";
            this.formdata.imageUrl1 = reader.result;
            this.visible1 = "block";
          });
          reader.readAsDataURL(files[0]);
          //this.image = files[0];
          const imageCompressor = new ImageCompressor();
          imageCompressor
            .compress(files[0], { quality: 0.8, width: 720, height: 1340 })
            .then((result) => {
              // Handle the compressed image file.
              if (result.size >= 1000000) {
                const imageCompressor = new ImageCompressor();
                imageCompressor
                  .compress(result, { quality: 0.5 })
                  .then((result) => {
                    const fileReader = new FileReader();

                    // This fires after the blob has been read/loaded.
                    fileReader.addEventListener("load", () => {
                      this.image1 = fileReader.result;

                      //console.log('image is',this.image1)
                    });

                    // Start reading the blob as text.
                    fileReader.readAsDataURL(result);

                    ////console.log(filename)
                    //console.log(result.size)
                    //console.log('image is',result)
                  });
              } else {
                var fileReader = new FileReader();
                fileReader.addEventListener("load", () => {
                  this.image1 = fileReader.result;

                  //console.log('else image is',this.image1)
                });
                fileReader.readAsDataURL(result);
                ////console.log(filename)
                //console.log('else',result.size)
                //console.log('ekse image is',result)
              }
            })

            .catch((err) => {
              // Handle the error
              //console.log("error is" + err)
            });
        }
      }
    },

    otherIMG(event) {
      var files = event.target.files;
      //console.log('files are', files)
      //console.log('imgfiles.length are', this.imgfiles.length)
      if (
        files.length > this.maxFiles ||
        this.imgfiles.length >= this.maxFiles ||
        files.length + this.imgfiles.length > this.maxFiles
      ) {
        alert("You can only upload a maximum of " + this.maxFiles + " files");
        return 0;
      } else {
        for (var i = 0; i < files.length; i++) {
          if (
            files[0].type == "image/png" ||
            files[0].type == "image/gif" ||
            files[0].type == "image/svg+xml" ||
            files[0].type == "image/tiff"
          ) {
            alert(
              "File " +
                files[0].name +
                " is not type of jpeg or jpg!. You cannot upload other types of images."
            );
          } else if (files[i].size > 5000200) {
            alert("File " + files[i].name + " is too large!");
          } else {
            var reader = new FileReader();

            reader.addEventListener("load", () => {
              //   document.getElementsByClassName('image-upload-wrap').hide();
              this.visible = "none";
              // this.logoimg = reader.result
              this.visible2 = "inline";
            });
            reader.readAsDataURL(files[i]);
            //console.log('files[0]', files[i])
            const imageCompressor = new ImageCompressor();
            imageCompressor
              .compress(files[i], { quality: 0.6, width: 720, height: 1340 })
              .then((result) => {
                // Handle the compressed image file.
                if (result.size >= 1000000) {
                  const imageCompressor = new ImageCompressor();
                  imageCompressor
                    .compress(result, { quality: 0.5 })
                    .then((result) => {
                      const fileReader = new FileReader();

                      // This fires after the blob has been read/loaded.
                      fileReader.addEventListener("load", () => {
                        this.imgfiles.push(fileReader.result);
                        var otherimg = fileReader.result;
                        this.otherimgs.push(otherimg);
                        //console.log('image is',this.otherimgs)
                      });

                      // Start reading the blob as text.
                      fileReader.readAsDataURL(result);

                      ////console.log(filename)
                      //console.log(result.size)
                      //console.log('image is',result)
                    });
                } else {
                  //  const reader = new FileReader();

                  //     // This fires after the blob has been read/loaded.
                  //     reader.addEventListener('loadend', (e) => {
                  //       this.image2 = e.srcElement.result;
                  //      //console.log('else image is',this.image2)
                  //     });

                  //     // Start reading the blob as text.
                  //     reader.readAsText(result);
                  var fileReader = new FileReader();
                  fileReader.addEventListener("load", () => {
                    this.imgfiles.push(fileReader.result);
                    var otherimg = fileReader.result;
                    this.otherimgs.push(otherimg);
                    //console.log('else image is',this.otherimgs)
                  });
                  fileReader.readAsDataURL(result);
                  ////console.log(filename)
                  //console.log('else',result.size)
                  //console.log('ekse image is',result)
                }
              })

              .catch((err) => {
                // Handle the error
                //console.log("error is" + err)
              });
          }
        }
      }
    },

    removeimg(i) {
      if (i > -1) {
        this.otherimgs.splice(i, 1);
        this.imgfiles.splice(i, 1);
      }
      //console.log('img files is', this.imgfiles)
      //console.log('otherimg is', this.otherimgs)
    },

    checkBarcode() {
      if (this.formdata.barcode) {
        this.$store.state.secondaryDatabase
          .collection("products")
          .where("owner", "==", firebase.auth().currentUser.uid)
          .where("barcode", "==", this.formdata.barcode)
          .limit(1)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const barcode = this.formdata.barcode;
              this.formdata.barcode = "";
              return this.$notify.error({
                title: "Error",
                message: "Barcode " + barcode + " is already used",
                type: "error",
              });
            });
          })
          .catch((error) => alert(error.message));
      }
    },

    submitForm(fdata) {
      if (this.shops[0].curProducts < this.shops[0].maxProducts) {
        this.$refs[fdata].validate((valid) => {
          if (valid && this.image1 != undefined) {
            this.loading = true;
            this.changed = false;
            this.backToTop();
            if (this.formdata.dis != 0) {
              this.formdata.disprice = this.formdata.price;
              this.formdata.price =
                this.formdata.price -
                (this.formdata.price * this.formdata.dis) / 100;
            } else if (this.formdata.dis == 0) {
              this.formdata.disprice = this.formdata.price;
            }
            var docID;
            this.$store.state.secondaryDatabase
              .collection("products")
              .add({
                name: this.formdata.name,
                cat: this.category,
                subcat: this.formdata.subcategory,
                loc: this.shops[0].loc,
                sname: this.shops[0].shopname,
                dis: this.formdata.dis,
                price: this.formdata.price,
                disprice: this.formdata.disprice,
                barcode: this.formdata.barcode,
                altertQunty: this.formdata.quantity,
                // priceList: this.formdata.priceList.map((price) => +price),
                // purchasedPriceList: this.formdata.purchasedPriceList.map(
                //   (price) => +price
                // ),
                profitMargin: this.formdata.profitMargin,
                priceList: this.formdata.priceData,
                variations: this.formdata.variations,
                colors: this.formdata.colors,
                expireDate: this.formdata.expireDate,
                brand: this.formdata.brand,
                rack: this.formdata.rack,
                color: this.formdata.color,
                cond: this.formdata.cond,
                type: this.formdata.type,
                war: this.formdata.warranty,
                desc: this.formdata.desc,
                img: this.image1,
                otherimgs: this.otherimgs,
                owner: firebase.auth().currentUser.uid,
                shopID: this.shops[0].id,
                details: {
                  model: this.formdata.model,
                  karat: this.formdata.karat,
                  metal: this.formdata.metal,
                  author: this.formdata.author,
                  publisher: this.formdata.publisher,
                  size: this.formdata.size,
                  screensize: this.formdata.screensize,
                  material: this.formdata.material,
                },
              })
              .then((docRef) => {
                docID = docRef.id;
                // if (!this.prdstat[firebase.auth().currentUser.uid]) {
                //   this.prdstat[firebase.auth().currentUser.uid] = 1;
                // } else if (this.prdstat[firebase.auth().currentUser.uid]) {
                //   this.prdstat[firebase.auth().currentUser.uid] += 1;
                // }
                // db.collection("aaa").doc("prdstat").update({
                //   prdno: this.prdstat,
                // });
                //console.log(docID)
                //console.log('docRef isss',docRef)
                let totalQnty = 0;
                this.formdata.priceData.forEach(item => totalQnty += item.quantity)
                const prdData = {
                  id: docRef.id,
                  name: this.formdata.name,
                  barcode: this.formdata.barcode,
                  altertQunty: this.formdata.quantity,
                  category: this.category,
                  subcategory: this.formdata.subcategory,
                  price: this.formdata.price,
                  brand: this.formdata.brand,
                  priceList: this.formdata.priceData,
                  profitMargin: this.formdata.profitMargin,
                  rack: this.formdata.rack,
                  totalQnty, 
                  //make sure to use same property name used in store.js getItems fun
                };

                if (this.$store.state.items[this.$route.params.cat]) {
                  // this.$store.state.items[this.$route.params.cat] = [];
                  
                  this.$store.state.items[this.$route.params.cat].push(prdData);
                  //console.log('store obj created',  this.$store.state.items[this.$route.params.cat])
                }

                if (this.$store.state.allProducts != undefined && this.$store.state.allProducts.length !== 0) {
                  
                  this.$store.state.allProducts.unshift({
                    ...prdData, 
                    img: this.image1,
                    _showDetails: false // toggle row details
                    //make sure to use same property name used in store.js getItems fun
                  });
                }

                this.$store.state.prdNameList.push({
                  name: this.formdata.name,
                  barcode: this.formdata.barcode,
                });
                let prds = 'prds';
                if(this.$store.state.noDB === true) {
                  prds = `prds${firebase.auth().currentUser.uid}`
                } 
                this.$store.state.secondaryDatabase
                  .collection("prdlist")
                  .doc(prds)
                  .set({ data: this.$store.state.prdNameList })
                  .then((doc) => {})
                  .catch((error) => {
                    alert(error);
                  });

                //console.log('# items are', this.shops[0].categories[this.category][this.formdata.subcategory])
                this.shops[0].catValues[this.category] += 1;
                this.shops[0].categories[this.category][
                  this.formdata.subcategory
                ] += 1;
                this.shops[0].curProducts += 1;
                if (
                  this.shops[0].curProducts >= 5 &&
                  this.shops[0].shopcat == "Vehicles"
                ) {
                  this.cansearch = "yes";
                } else if (
                  this.shops[0].curProducts >= 10 &&
                  this.shops[0].shopcat != "Vehicles"
                ) {
                  this.cansearch = "yes";
                }
                //console.log('# updated items are', this.shops[0].categories[this.category][this.formdata.subcategory])
                this.$store.state.secondaryDatabase
                  .collection("shops")
                  .doc(this.shops[0].id)
                  .update({
                    categories: this.shops[0].categories,
                    curProducts: this.shops[0].curProducts,
                    search: this.cansearch,
                    catValues: this.shops[0].catValues,
                  })
                  .then((doc) => {
                    this.formdata = {
                      name: "",
                      price: 0,
                      dis: 0,
                      disprice: 0,
                      barcode: "",
                      quantity: 1,
                      priceList: [],
                      profitMargin: 0,
                      priceData: this.$store.state.stores.map((store) => {
                        return {
                          purcPr: 0,
                          sellPr: 0,
                          quantity: 0,
                          store: store.id,
                        };
                      }),
                      purchasedPriceList: [],
                      variations: [],
                      colors: [],
                      expireDate: "",
                      subcategory: "",
                      brand: "",
                      model: "",
                      karat: "",
                      metal: "",
                      author: "",
                      publisher: "",
                      size: "",
                      screensize: "",
                      material: "",
                      color: "",
                      cond: "",
                      type: "",
                      warranty: "",
                      desc: "",
                      image: null,
                      imageUrl1: "",
                      imageUrl2: "",
                      imageUrl3: "",
                      owner: "",
                      isLoggedIn: false,
                      currentUser: false,
                      rack: "",
                    };
                    this.imgfiles = [];
                    this.otherimgs = [];
                    this.image1 =
                      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAwMDAwNDA4PDw4TFRIVExwaGBgaHCseIR4hHitBKC8oKC8oQTlFODQ4RTlnUUdHUWd3ZF5kd5CAgJC1rLXs7P8BDAwMDA0MDg8PDhMVEhUTHBoYGBocKx4hHiEeK0EoLygoLyhBOUU4NDhFOWdRR0dRZ3dkXmR3kICAkLWstezs///CABEIAWgBaAMBIgACEQEDEQH/xAAbAAEBAQEBAQEBAAAAAAAAAAAAAwIFBgQBB//aAAgBAQAAAAD+pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ/gAAAAB+0AEsgAAAAGqgCWQAAAADVQBLIAAAABqoAlkAAAAA1UASyAAAAAaqAJZAAAAANVAEsgAAAAGqgCWQAAAADVQBLIAAAABqoAlkAAAAA1UASyAAAAAaqAJZAOBoADPfANVAEsgHB7wAHB7wBqoAlkA4PeA+HiekqcHvAGqgCWQDg94DzXnvZ9M4PeANVAEsgHB7wGPh6I4PeANVAEsgHB7z5PK+uuGdOD3gDVQBLIBwe98ni4fX7S5weH7WvB7wBqoAlkA4PT8XA+v2l+D5d9nteN3gDVQBLIB5jjwD6+z5sfZ1/RgGqgCWQDwvxgAfb7kA1UASyAeW54AHQ9SAaqAJZAAAAANVAEsgAAAAGqgCWQAAAADVQBLIAAAABqoAlkAAAAA1UASyAAAAAaqAJZAAAAANVAEsgAAAAGqgCWQAAAADVQBLIAAAABqoAlkAAAAA1UAT/AAAAAD9oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oACAECEAAAAKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALAAADRKkAALQMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB//xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAIAQMQAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlAAAMli0AAkA0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH//EADEQAAECBQEGBQIHAQAAAAAAAAIBBAADEjAyBRE1UFFUcRAUFSAhMZETIzRBcHOxQv/aAAgBAQABPwD+ZiJUWKiiooqKKiiooqKKiiooqKKiiooqKKiiooqKKiiooqKKiiooqKKiiooqKKiiooqKKiiooqKKiiooqKBJVW2eS8CDJLZ5LwIMktnkvAgyS2eS8CDJLZ5LwIMktnkvAgyS2eS8CDJLZ5LwIMktnkvAgyS2eS8CDJLZ5LwIMktnktqdPfuX01u3mpLSVHlNZ60Y8prPWjHlNZ60Y8prPWjHlNZ60Y8prPWjHlNZ60Y8prPWjHlNZ60Y8prPWjHlNZ60Y8prPWjHlNZ60Ykz37Z9KbuJqTEmpaDJLZ5LaZb4fdlvPN8seyWgyS2eS2mW+H3ZbD58DOWhKlRFiMBr0+vacoFHkkSZoT5QzQXaJJ8ex5vlj2S0GSWzyW0y3w+7LY1+WdciZ/zSo+GkSzBiFSZKRJ2X2PN8seyWgyS2eS2mW+H3ZbEyWE0FAxQhX6osBpTADqST91VU9rzfLHsloMktnktplvh92XxePJTSVWfyq4jzWJeqOhdLPItu36h+2yG7iU5lJMlrtRfui8l9yEJbaVRdi7F2c+Xi83yx7JaDJLZ5LaZb4fdl8HjyU0lVn8quI81hw4muZqzJi7V/xOSeDN5NaTaw+i5Dzhu4lOZSTJa7UX7ovJfZqmqfhVSJBfmfQi5QyfTWc2ofkFzHnEifLnyhmSy2ivg83yx7JaDJLZ5LaZb4fdlh48lNJVZ/KriPNYcOJrmasyYu1f8AE5J7Gbya0m1h8ouQ80hu4lOZSTJa7UX7ovJfDVNU/CqkSC/M+hFy8WT2Yzm1D8guQ84kT5c+UMyWW0Vh5vlj2S0GSWzyW0jsGmpP5h8lQU5rDhxNczVmTF2r/ick9zN5NaTaw+i5Dzh9rILKQWyrUafJfuPtZPZjObUPyC5DzidPlz9UYTJZbRVEtBkls8ltaj+uc/2Le039e2/stBkls8ltajpronUybKBTE1q+I9Nf9Mcemv8Apjj01/0xx6a/6Y49Nf8ATHHpr/pjj01/0xx6a/6Y49Nf9Mcemv8Apjj01/0xx6a/6Y49Nf8ATHGm6a6F1LmzZagILt+bQZJbPJeBBkls8l4EGSWzyXgQZJbPJeBBkls8l4EGSWzyXgQZJbPJeBBkls8l4EGSWzyXgQZJbPJeBBkls8l4EGSWyFVWKSikopKKSikopKKSikopKKSikopKKSikopKKSikopKKSikopKKSikopKKSikopKKSikopKKSikopKBFUX+Z//8QAGhEAAgMBAQAAAAAAAAAAAAAAAREQQHAAUP/aAAgBAgEBPwDRl5hNRcRKpCVKoDX/AP/EABkRAQADAQEAAAAAAAAAAAAAAAEQEUBwAP/aAAgBAwEBPwDuQZL8MjiWbm8D1/8A/9k=";
                    this.loading = false;
                    this.changed = true;
                    this.modalShow2 = true;
                    //console.log('doc is', doc)
                  });
                return docID;
              })
              .catch((error) => alert(error));
          } else {
            if (this.image1 == undefined) {
              alert("Add a main image!!!");
              this.backToTop();
            }
            alert("error occured");
            this.backToTop();
            return false;
          }
        });
      } else {
        this.modalShow = true;
      }
    },
    resetForm(formName) {
      //console.log(formName)
      this.$refs[formName].resetFields();
      this.formdata.imageUrl1 = "";
      this.imgfiles = [];
      this.otherimgs = [];
    },

    //    initToTopButton: function() {
    //   $(document).bind('scroll', function() {
    //     var backToTopButton = $('.goTop');
    //     if ($(document).scrollTop() > 250) {
    //       backToTopButton.addClass('isVisible');
    //       this.isVisible = true;
    //     } else {
    //       backToTopButton.removeClass('isVisible');
    //       this.isVisible = false;
    //     }
    //   }.bind(this));
    // },
    backToTop: function () {
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        "slow",
        "swing"
      );
    },
  },

  created() {
    //  this.$nextTick(function() {
    //      this.initToTopButton();
    //   })
    this.backToTop();
    if (screen.width > 575) {
      this.labelPosition = "left";
    } else {
      this.labelPosition = "top";
      this.priceTableWidth = "80%";
    }
    if (firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;

      //console.log(firebase.auth().currentUser.uid)
    }

    this.$store.state.secondaryDatabase
      .collection("shops")
      .where("owner", "==", firebase.auth().currentUser.uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            categories: doc.data().categories,
            shopcat: doc.data().cat,
            shoptype: doc.data().shoptype,
            curProducts: doc.data().curProducts,
            maxProducts: doc.data().maxProducts,
            loc: doc.data().location,
            shopname: doc.data().name,
            catValues: doc.data().catValues,
            cansearch: doc.data().search,
          };
          this.shops.push(data);
          this.shopcat = this.shops[0].shopcat;
          this.shoptype = this.shops[0].shoptype;
          this.category = this.$route.params.cat;
          this.subcategories = this.shops[0].categories[this.$route.params.cat];
          this.cansearch = this.shops[0].cansearch;

          //console.log('this.subcategories is', this.subcategories)
        });
      });
    // db.collection("aaa")
    //   .doc("prdstat")
    //   .get()
    //   .then((doc) => {
    //     this.prdstat = doc.data().prdno;
    //   });
  },
  mounted() {},
};
</script>

<style scoped>
@import url("~@/assets/admin/css/imgupload.css");
@import url("~@/assets/admin/css/admin-loader.css");
</style>


// WEBPACK FOOTER //
// src/components/admin/commonProducts.vue